// extracted by mini-css-extract-plugin
export default {"txt2Wrapper":"cafe_txt2Wrapper__ouAbJ","txt2":"cafe_txt2__1b+Vs"};